import { error } from "pdf-lib";
import React, { useState, useEffect } from "react";
import { Row, Col, Input, FormGroup, Label, FormText } from "reactstrap";

export default function TimeSelector({ label, value, onChange, col,errorMsg }) {

  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [ampm, setAmpm] = useState("");

  useEffect(() => {
  if (value) {
    // Expected format: "hh:mm AM"
    const [time, meridian] = value.split(" ");
    if (!time || !meridian) return;

    const [h, m] = time.split(":");

    setHour(h);
    setMinute(m);
    setAmpm(meridian);
  }
}, [value]);


  // When user changes anything → combine and send to parent
  useEffect(() => {
    if (hour && minute && ampm) {
      onChange(`${hour}:${minute} ${ampm}`);
    }
  }, [hour, minute, ampm]);


  const hourOptions = Array.from({ length: 12 }, (_, i) => {
    const h = i + 1;
    return h.toString().padStart(2, '0');
  });

  const minuteOptions = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, '0')
  );

  return (
    <FormGroup className={col || "col-4"}>
      <Label>{label}</Label>

      <Row>
        <Col xs="4">
        <FormText className="text-center" for="hourSelect">Hr</FormText>
          <Input
            type="select"
            className="custom-select"
            value={hour}
            onChange={(e) => setHour(e.target.value)}
          >
            <option value="">--</option>
            {hourOptions.map(h => <option key={h}>{h}</option>)}
          </Input>
        </Col>

        <Col xs="4">
        <FormText className="text-center" for="minuteSelect">Min</FormText>
          <Input
            type="select"
            className="custom-select"
            value={minute}
            onChange={(e) => setMinute(e.target.value)}
          >
            <option value="">--</option>
            {minuteOptions.map(m => <option key={m}>{m}</option>)}
          </Input>
        </Col>

        <Col xs="4">
        <FormText className="text-center" for="ampmSelect">AM/PM</FormText>
          <Input
            type="select"
            className="custom-select"
            value={ampm}
            onChange={(e) => setAmpm(e.target.value)}
          >
            <option value="">--</option>
            <option>AM</option>
            <option>PM</option>
          </Input>

        </Col>
      </Row>

      <FormText>
        Selected: <b>{value || "--"}</b>
      </FormText>
       {errorMsg && (
                      <FormText color="danger">{errorMsg}</FormText>
        )}
    </FormGroup>
  );
}
